<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="pg4sec1" title="Anatomy of a Letter">
<p class="h2a"><span class="right_1" epub:type="pagebreak" id="page_4" title="4">ANATOMY of a LETTER</span></p>
<p class="centertal"><i>THE STRUCTURE OF A CHARACTER</i></p>
<figure>
<p class="imaget"><img alt="" height="453" src="images/f0004-01.jpg" width="544"/></p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Intsec3.vue?0bdaff4b